import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { adminPartnersApi as n } from "@maat/api-main";
//#region src/partners/admin/useAdminPartnerConversionsQuery.ts
var r = (r) => t({
	queryKey: e.conversions(r),
	fetchPage: (e) => n.conversions(r, { page: e }),
	key: "conversions",
	enabled: !!r
});
//#endregion
export { r as useAdminPartnerConversionsQuery };
